/**
 * @import {UserProfileImageApi} from './api.js';
 */

import {reactive} from 'nova';
import {NaN} from '@acng/frontend-bounty/std/value.js';

class UserImageWaiting {
  // DEBUG = true;
  id = NaN;
  @reactive accessor image = '';
  @reactive accessor inactive = true;
  @reactive accessor active = false;

  /**
   * @param {Awaited<ReturnType<UserProfileImageApi['get']>>} waitingImage
   */
  set(waitingImage) {
    this.id = waitingImage ? waitingImage.id : NaN;
    this.image = waitingImage ? waitingImage.wide[900] : '';
    this.inactive = !waitingImage;
    this.active = !!waitingImage;
  }
}

export {UserImageWaiting};
